import axios from 'axios';
import { route } from 'ziggy';
import {Ziggy} from "../../ziggy";
const gr = (name, params) => {
    return String(route(name, params, false, Ziggy));
};

const state = {
    cart:{},
};

const getters = {
    getCart: state => state.cart,
};

const actions = {
    fetchCart: function (store) {
        axios.get(gr('api.v1.cart.index'))
            .then(response => store.commit('CART_SET', response.data))
            .catch(e => console.log(e))
    },
};

const mutations = {
    CART_SET: (state, payload) => state.cart = payload,
};

export default {
    state: state,
    mutations: mutations,
    actions: actions,
    getters: getters,
};
